import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/button';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { useProjectsService } from '@/services/projects';
import { SearchBar } from '@/shared/SearchBar';
import { FolderOpen, Plus } from 'lucide-react';
import { useState, type FC } from 'react';
import { CreateProjectDialog } from './components/CreateProjectDialog';
import { ProjectsTable } from './components/ProjectsTable';

export const ProjectsPage: FC = () => {
  const { projects, isPending } = useProjectsService();
  const [searchString, setSearchString] = useState('');
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const isEmpty = projects.length === 0;

  return (
    <FlexCol p="6" w="full" gap="6" className="max-w-[1600px]">
      <FlexRow alignItems="center" justifyContent="between" w="full">
        <PageHeader
          title="Projects"
          subtitle="Organize your chats and table views"
        >
          <FolderOpen size={22} />
        </PageHeader>
        {!isEmpty && (
          <Button onClick={() => setIsCreateOpen(true)}>
            <Plus />
            New Project
          </Button>
        )}
      </FlexRow>

      {isEmpty && !isPending ? (
        <FlexCol
          alignItems="center"
          justifyContent="center"
          gap="4"
          className="flex-1 py-16"
        >
          <FlexCol
            p="4"
            className="border-2 border-dashed border-neutral-200 rounded-lg bg-white w-full"
            alignItems="center"
            justifyContent="center"
            gap="4"
          >
            <FolderOpen className="h-10 w-10 bg-neutral-100 rounded-md p-3" />
            <FlexCol gap="2" alignItems="center" justifyContent="center">
              <Text variant="body-sm-bold">No projects yet</Text>
              <Text className="text-gray-500" variant="body-sm">
                Create your first project to organize chats and table views
              </Text>
            </FlexCol>
            <Button onClick={() => setIsCreateOpen(true)}>
              <Plus />
              New Project
            </Button>
          </FlexCol>
        </FlexCol>
      ) : (
        <>
          <SearchBar
            searchString={searchString}
            setSearchString={setSearchString}
            placeholder="Search projects..."
            className="w-[300px]"
          />
          <ProjectsTable searchString={searchString} />
        </>
      )}

      <CreateProjectDialog open={isCreateOpen} onOpenChange={setIsCreateOpen} />
    </FlexCol>
  );
};
